import React from "react";
import { ApiChannel } from "../types/apiChannel.types";
import { toast } from "react-hot-toast";

const copyToClipboard = (text: string, label: string) => {
  navigator.clipboard
    .writeText(text)
    .then(() => {
      toast.success(`${label} copied to clipboard!`);
    })
    .catch(() => {
      toast.error(`Failed to copy ${label}`);
    });
};

// Function to generate script
const generateScript = (apiChannel: ApiChannel) => {
  const script = `
// Generated API Script for ${apiChannel.channelName}
// API Key: ${apiChannel.apiKey}
// Full URL: ${apiChannel.fullUrl}

const sendDataToAPI = async (leadData) => {
  try {
    const apiKey = "${apiChannel.apiKey}";
    const baseUrl = "${apiChannel.fullUrl}";
    
    // Construct URL with parameters
    const url = \`\${baseUrl}?api_key=\${apiKey}&source=\${leadData.source || 'MagicBricks'}&mobile=\${leadData.mobile}&email=\${leadData.email}&time=\${leadData.time || new Date().toLocaleTimeString()}&isd=\${leadData.isd || '91'}&name=\${leadData.name}&msg=\${leadData.msg || 'testlead'}&project=\${leadData.project || '********'}\`;
    
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': '*/*'
      },
      body: JSON.stringify(leadData)
    });
    
    const result = await response.json();
    console.log('API Response:', result);
    return result;
  } catch (error) {
    console.error('Error sending data to API:', error);
    throw error;
  }
};
`;

  // Copy to clipboard
  navigator.clipboard
    .writeText(script)
    .then(() => {
      toast.success("Script copied to clipboard!");
    })
    .catch((err) => {
      console.error("Failed to copy script:", err);
      toast.error("Failed to copy script");
      // Fallback: show script in a modal or new window
      const newWindow = window.open("", "_blank");
      newWindow?.document.write(`<pre>${script}</pre>`);
    });
};

export const getApiChannelTableColumns = (
  handleEdit: (apiChannel: ApiChannel) => void
) => [
  {
    name: "Channel Name",
    selector: (row: ApiChannel) => row.channelName,
    sortable: true,
    cell: (row: ApiChannel) => (
      <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
        <div
          style={{
            width: "24px",
            height: "24px",
            borderRadius: "50%",
            backgroundColor: "rgb(167 133 144)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "white",
            fontSize: "10px",
            fontWeight: "bold",
          }}
        >
          {row.channelName.charAt(0).toUpperCase()}
        </div>
        <span style={{ fontWeight: "500", color: "#33475b" }}>
          {row.channelName}
        </span>
      </div>
    ),
    width: "230px",
  },
  {
    name: "API Type",
    selector: (row: ApiChannel) => row.apiTypeName,
    sortable: true,
    cell: (row: ApiChannel) => row.apiTypeName,
    width: "220px",
  },
  {
    name: "API Key",
    selector: (row: ApiChannel) => row.apiKey,
    sortable: false,
    cell: (row: ApiChannel) => (
      <div className="d-flex align-items-center gap-2">
        <code
          style={{
            fontSize: "12px",
            backgroundColor: "#f8f9fa",
            padding: "2px 6px",
            borderRadius: "4px",
            maxWidth: "150px",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          {row.apiKey.substring(0, 20)}...
        </code>
        <span
          className="icon-btn icon-copy"
          onClick={() => copyToClipboard(row.apiKey, "API Key")}
          style={{ cursor: "pointer", color: "#6c757d", fontSize: "14px" }}
          title="Copy API Key"
        ></span>
      </div>
    ),
    width: "330px",
  },
  {
    name: "Full URL",
    selector: (row: ApiChannel) => row.fullUrl,
    sortable: false,
    cell: (row: ApiChannel) => (
      <div className="d-flex align-items-center gap-2">
        <code
          style={{
            fontSize: "12px",
            backgroundColor: "#f8f9fa",
            padding: "2px 6px",
            borderRadius: "4px",
            maxWidth: "200px",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          {row.fullUrl.substring(0, 40)}...
        </code>
        <span
          className="icon-copy"
          onClick={() => copyToClipboard(row.fullUrl, "Full URL")}
          style={{ cursor: "pointer", color: "#6c757d", fontSize: "14px" }}
          title="Copy Full URL"
        ></span>
      </div>
    ),
    width: "300px",
  },
  {
    name: "Generate Script",
    cell: (row: ApiChannel) => (
      <button
        className="btn btn-primary btn-sm"
        onClick={() => generateScript(row)}
        title="Generate API Script"
        style={{
          fontSize: "12px",
          padding: "4px 8px",
          borderRadius: "4px",
          backgroundColor: "#007bff",
          border: "none",
          color: "white",
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          gap: "4px",
        }}
      >
        <i className="bi bi-code-square"></i>
        Generate
      </button>
    ),
    ignoreRowClick: true,
    allowOverflow: true,
    button: true,
    width: "120px",
  },
  {
    name: "",
    cell: (row: ApiChannel) => (
      <div className="action-cell">
        <button
          className="action-button edit-button"
          onClick={() => handleEdit(row)}
          title="Edit"
        >
          <i className="bi bi-pencil-square"></i>
        </button>
        <button className="action-button more-button" title="More options">
          <i className="bi bi-three-dots"></i>
        </button>
      </div>
    ),
    ignoreRowClick: true,
    allowOverflow: true,
    button: true,
    width: "80px",
  },
];
